module.exports = "<ul class=list-unstyled _v-496547dc=\"\"><li v-for=\"d in data\" _v-496547dc=\"\"><a href=# @click=select(d) :class=\"{active: d == value}\" _v-496547dc=\"\">{{d}}</a></li></ul>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-496547dc!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/component/filter-list.vue
// module id = 373
// module chunks = 0